import axios from '@axios'

/** 
* Índice
* {@link getClassrooms} - Obtener aulas
* {@link getClassroom} - Obtener aula
* {@link addClassroom} - Crear aula
* {@link deleteClassroom} - Eliminar aula
* {@link updateClassroom} - Actualizar aula
*/

    /**
     * Obtener todads las aulas
     * @param {*} queryParams 
     * @returns classrooms 
     */
    export const getClassrooms = function (queryParams) {
        try {
            return new Promise((resolve, reject) => {
                axios
                    .get('/classrooms', { params: queryParams })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })

        } catch (error) {
            return error
        }
    }

    /**
     * Obtener aula
     * @param {integer} id ID de la aula 
     * @returns classroom
     */

    export const getClassroom = function ( id ) {
        try {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/classrooms/${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })

        } catch (error) {
            return error
        }
    }

    /**
     * Añadir aula
     * @param {*} data Datos del cliente 
     * @returns 
     */

    export const addClassroom = function (data) {
        try {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/classrooms`, data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })

        } catch (error) {
            return error
        }
    }

    /**
     * Borrar aula
     * @param {integer} id ID de la aula a borrar
     * @returns 
     */

    export const deleteClassroom = function ({ id }) {
        try {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/classrooms/${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })

        } catch (error) {
            return error
        }
    }

    /**
     * Actualizar aula
     * @param {integer} id ID de la aula a actualizar 
     * @returns 
     */

    export const updateClassroom = function (data) {
        try {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/classrooms/${data.id}`, data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })

        } catch (error) {
            return error
        }
    }










